/* Lapiaf - integridad de la linea oculta "Filtro incluido" (suscripcion $0)
   Regla: la linea con propiedad _lpf_incluido tiene SIEMPRE la misma cantidad
   que las lineas visibles del producto padre (handle guardado en la propiedad).
   v2 (un solo render): los cambios de cantidad del padre se REESCRIBEN antes de
   salir a un unico /cart/update.js que mueve padre+filtro juntos con el mismo
   bundle de secciones de Eurus; la correccion residual (carritos manipulados)
   pinta con reRenderSections(sections) en vez de reLoad (sin spinner ni fetch
   extra). Snapshot del carrito mantenido desde las respuestas para mapear
   linea->key; sin snapshot cae al comportamiento reactivo como red de seguridad. */
(function () {
  try { sessionStorage.removeItem('lpf_up_done'); } catch (e) {}
  var PROP = '_lpf_incluido';
  var CODE = 'DESCUENTOESPECIAL';   // codigo del descuento de suscripcion (visible al cliente)
  var NOCODE = 'LAPIAF-NA';         // codigo inexistente: "limpia" el aplicado
  var SUPCODE = 'SUMINISTRO200';    // oferta por suministro: filtros de repuesto -$200 c/u
  var GIFTPROP = '_lpf_gratis';     // oferta anual: filtros de regalo (siempre 4 x ducha, en $0)
  var GIFTCODE = 'FILTROSGRATIS';   // -$479 c/u sobre el filtro: deja la linea de regalo en $0
  var GIFTX = 4;                    // filtros gratis por cada ducha
  var FILTRO_ID = '54026359767315'; // variante del filtro oficial de repuesto
  var DUCHA_HANDLE = 'ducha-purificadora';
  var UP_KEY = 'lpf_up_pause';
  var upPaused = false;
  try { upPaused = sessionStorage.getItem(UP_KEY) === '1'; } catch (e) {}
  function hideUp() {
    if (!upPaused) return;
    var el = document.getElementById('lpf-up');
    if (el) el.remove();
  }
  function pauseUp() {
    upPaused = true;
    try { sessionStorage.setItem(UP_KEY, '1'); } catch (e) {}
    hideUp();
  }
  function resumeUp() {
    if (!upPaused) return;
    upPaused = false;
    try { sessionStorage.removeItem(UP_KEY); } catch (e) {}
  }
  var syncing = false;
  var lastCart = null;
  var giftQtyPrev = null;

  /* Pop visual del chip "xN incluidos" cuando cambia la cantidad de filtros
     de regalo (el drawer se re-renderiza, asi que se busca el chip nuevo). */
  function giftQtyOf(cart) {
    var q = 0;
    cart.items.forEach(function (l) { if (l.properties && l.properties[GIFTPROP]) q += l.quantity; });
    return q;
  }
  function popGiftChip(gq) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      var hit = null;
      document.querySelectorAll('.lpf-gift-chip').forEach(function (el) {
        if (el.textContent.indexOf('×' + gq) !== -1) hit = el;
      });
      if (hit) {
        clearInterval(t);
        hit.classList.remove('lpf-gift-pop');
        void hit.offsetWidth;
        hit.classList.add('lpf-gift-pop');
        setTimeout(function () { hit.classList.remove('lpf-gift-pop'); }, 900);
      } else if (tries > 25) {
        clearInterval(t);
      }
    }, 100);
  }

  function rememberCart(c) {
    if (c && c.items && typeof c.item_count === 'number') {
      lastCart = c;
      var gq = giftQtyOf(c);
      if (giftQtyPrev !== null && gq !== giftQtyPrev && gq > 0) popGiftChip(gq);
      giftQtyPrev = gq;
      if (c.item_count === 0) resumeUp();
      syncCode(c);
    }
  }

  /* Candado del codigo de suscripcion (la ducha queda en $899):
     Shopify ahora ADHIERE los codigos al carrito (cart.discount_codes) y el
     endpoint /discount/X solo AGREGA — nunca quita. Por eso el candado trabaja
     sobre el estado real del carrito, en ambas direcciones:
       - hay suscripcion y el codigo no esta adherido -> /discount/CODE lo adhiere
       - NO hay suscripcion y hay codigos adheridos -> /cart/update.js {discount:""}
         los despega (unica via que existe para quitarlos). */
  function syncCode(cart) {
    try {
      var has = cart.items.some(function (l) { return l.properties && l.properties[PROP]; });
      var codes = cart.discount_codes || [];
      var applied = codes.some(function (c) { return c.code === CODE && c.applicable !== false; });
      if (has && !applied) {
        return fetch('/discount/' + CODE, { credentials: 'same-origin' })
          .then(function () { paint(null); }).catch(function () {});
      }
      var duchaQ = 0;
      cart.items.forEach(function (l) { if (l.handle === DUCHA_HANDLE && !(l.properties && l.properties[PROP])) duchaQ += l.quantity; });
      var gift = cart.items.some(function (l) { return l.properties && l.properties[GIFTPROP]; });
      if (!has && gift && duchaQ > 0) {
        var giftApplied = codes.some(function (c) { return c.code === GIFTCODE && c.applicable !== false; });
        if (!giftApplied) {
          return fetch('/discount/' + GIFTCODE, { credentials: 'same-origin' })
            .then(function () { paint(null); }).catch(function () {});
        }
        return Promise.resolve();
      }
      var supl = cart.items.some(function (l) { return String(l.variant_id || l.id) === FILTRO_ID && !(l.properties && l.properties[GIFTPROP]); }) &&
                 duchaQ > 0;
      if (!has && supl) {
        var supApplied = codes.some(function (c) { return c.code === SUPCODE && c.applicable !== false; });
        if (!supApplied) {
          return fetch('/discount/' + SUPCODE, { credentials: 'same-origin' })
            .then(function () { paint(null); }).catch(function () {});
        }
        return Promise.resolve();
      }
      if (!has && codes.length) {
        // limpieza DOBLE: la cookie (o el checkout re-aplica el codigo) y los adheridos al carrito.
        // Con el carrito VACIO se limpia en silencio: repintar aqui causaba un segundo
        // reLoad visible (el "atoron" al eliminar la ultima ducha).
        return fetch('/discount/' + NOCODE, { credentials: 'same-origin' }).catch(function () {}).then(function () {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: '' })
          });
        }).then(function () { if (cart.item_count > 0) paint(null); }).catch(function () {});
      }
      return Promise.resolve();
    } catch (e) { return Promise.resolve(); }
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { rememberCart(c); return c; });
  }

  function subLines(cart) {
    return cart.items.filter(function (l) { return l.properties && l.properties[PROP]; });
  }

  function parentQty(cart, handle) {
    var q = 0;
    cart.items.forEach(function (l) {
      if (l.handle === handle && !(l.properties && l.properties[PROP])) q += l.quantity;
    });
    return q;
  }

  function computeUpdates(cart) {
    var updates = {};
    var changed = false;
    subLines(cart).forEach(function (line) {
      var want = parentQty(cart, line.properties[PROP]);
      if (line.quantity !== want) { updates[line.key] = want; changed = true; }
    });
    // filtros de regalo (oferta anual): el total es SIEMPRE GIFTX x duchas; sin ducha se van
    var gifts = cart.items.filter(function (l) { return l.properties && l.properties[GIFTPROP]; });
    if (gifts.length) {
      var giftWant = parentQty(cart, DUCHA_HANDLE) * GIFTX;
      if (gifts[0].quantity !== giftWant) { updates[gifts[0].key] = giftWant; changed = true; }
      gifts.slice(1).forEach(function (g) { updates[g.key] = 0; changed = true; });
    }
    return changed ? updates : null;
  }

  /* Oferta anual: si hay ducha y la linea de regalo no existe (solo en la landing
     con la bandera activa), se agrega sola con GIFTX filtros por ducha. */
  function ensureGift(cart) {
    try {
      if (!window.__lpfAnnualGift) return Promise.resolve(false);
      var duchaQ = parentQty(cart, DUCHA_HANDLE);
      if (!duchaQ) return Promise.resolve(false);
      var has = cart.items.some(function (l) { return l.properties && l.properties[GIFTPROP]; });
      if (has) return Promise.resolve(false);
      var item = { id: parseInt(FILTRO_ID, 10), quantity: duchaQ * GIFTX, properties: {} };
      item.properties[GIFTPROP] = '1';
      var body = { items: [item] };
      var ids = sectionIds();
      if (ids) { body.sections = ids; body.sections_url = window.location.pathname; }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (c) {
        rememberCart(c);
        paint(c && c.sections);
        return true;
      }).catch(function () { return false; });
    } catch (e) { return Promise.resolve(false); }
  }

  function sectionIds() {
    try {
      if (window.Alpine && Alpine.store('xCartHelper') && Alpine.store('xCartHelper').getSectionsToRender) {
        return Alpine.store('xCartHelper').getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) { /* Alpine aun no listo */ }
    return null;
  }

  function paint(sections) {
    try {
      if (sections && window.Alpine && Alpine.store('xCartHelper') && Alpine.store('xCartHelper').reRenderSections) {
        Alpine.store('xCartHelper').reRenderSections(sections);
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        return;
      }
    } catch (e) { /* cae al reLoad */ }
    try {
      if (window.Alpine && Alpine.store('xMiniCart') && Alpine.store('xMiniCart').reLoad) Alpine.store('xMiniCart').reLoad();
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    } catch (e) { /* el drawer se refresca en la proxima apertura */ }
  }

  function syncNow() {
    if (syncing) return Promise.resolve(false);
    syncing = true;
    return getCart().then(function (cart) {
      var updates = computeUpdates(cart);
      if (!updates) {
        return ensureGift(cart).then(function (added) { syncing = false; return added; });
      }
      var body = { updates: updates };
      var ids = sectionIds();
      if (ids) { body.sections = ids; body.sections_url = window.location.pathname; }
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (c) {
        rememberCart(c);
        syncing = false;
        paint(c && c.sections);
        return true;
      });
    }).catch(function () { syncing = false; return false; });
  }

  var timer;
  function syncSoon() { clearTimeout(timer); timer = setTimeout(syncNow, 200); }

  /* Reescritura proactiva: un /cart/change del producto padre se convierte en
     UN /cart/update.js que mueve padre y filtro juntos (mismo bundle de
     secciones -> un solo render y nada que corregir despues). Cubre la linea
     de suscripcion (_lpf_incluido) Y los filtros de regalo de la oferta anual
     (_lpf_gratis: siempre GIFTX por ducha). */
  function rewriteChange(init) {
    try {
      if (!lastCart || !init || typeof init.body !== 'string') return null;
      var subs = subLines(lastCart);
      var gifts = lastCart.items.filter(function (l) { return l.properties && l.properties[GIFTPROP]; });
      if (!subs.length && !gifts.length) return null;
      var body = JSON.parse(init.body);
      var qty = parseInt(body.quantity, 10);
      if (isNaN(qty) || qty < 0) return null;
      var target = null;
      if (body.line) {
        target = lastCart.items[parseInt(body.line, 10) - 1];
      } else if (body.id) {
        target = lastCart.items.filter(function (l) {
          return l.key === body.id || String(l.id) === String(body.id);
        })[0];
      }
      if (!target || (target.properties && (target.properties[PROP] || target.properties[GIFTPROP]))) return null;
      var updates = {};
      var touches = false;
      subs.forEach(function (s) {
        if (s.properties[PROP] === target.handle) { updates[s.key] = qty; touches = true; }
      });
      if (gifts.length && target.handle === DUCHA_HANDLE) {
        var duchaTotal = qty;
        lastCart.items.forEach(function (l) {
          if (l.handle === DUCHA_HANDLE && l.key !== target.key && !(l.properties && (l.properties[PROP] || l.properties[GIFTPROP]))) duchaTotal += l.quantity;
        });
        updates[gifts[0].key] = duchaTotal * GIFTX;
        gifts.slice(1).forEach(function (g) { updates[g.key] = 0; });
        touches = true;
      }
      if (!touches) return null;
      updates[target.key] = qty;
      var newBody = { updates: updates };
      if (body.sections) newBody.sections = body.sections;
      if (body.sections_url) newBody.sections_url = body.sections_url;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(newBody)
      });
    } catch (e) { return null; }
  }

  /* ¿Lo que se va a agregar lleva suscripcion? (selling_plan presente y con valor) */
  function addWantsSub(init) {
    try {
      var b = init && init.body;
      if (!b) return null;
      if (typeof FormData !== 'undefined' && b instanceof FormData) {
        var v = false;
        b.forEach(function (val, key) { if (/selling_plan/.test(key) && val) v = true; });
        return v;
      }
      if (typeof b === 'string') return /selling_plan"?\s*[:=]\s*"?\d/.test(b);
    } catch (e) {}
    return null;
  }

  /* ¿Lo que se va a agregar trae filtros de regalo de la oferta anual? */
  function addWantsGift(init) {
    try {
      var b = init && init.body;
      if (!b) return false;
      if (typeof FormData !== 'undefined' && b instanceof FormData) {
        var v = false;
        b.forEach(function (val, key) { if (key.indexOf(GIFTPROP) !== -1) v = true; });
        return v;
      }
      if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) return b.toString().indexOf(GIFTPROP) !== -1;
      if (typeof b === 'string') return b.indexOf(GIFTPROP) !== -1;
    } catch (e) {}
    return false;
  }

  /* ¿Lo que se va a agregar incluye el filtro de repuesto oficial? (oferta suministro) */
  function addWantsSupply(init) {
    try {
      var b = init && init.body;
      if (!b) return false;
      if (typeof FormData !== 'undefined' && b instanceof FormData) {
        var v = false;
        b.forEach(function (val, key) { if (/items\[\d+\]\[id\]/.test(key) && String(val) === FILTRO_ID) v = true; });
        return v;
      }
      if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) return b.toString().indexOf(FILTRO_ID) !== -1;
      if (typeof b === 'string') return b.indexOf(FILTRO_ID) !== -1;
    } catch (e) {}
    return false;
  }

  // Candado 1: interceptar mutaciones del carrito (reescribir o re-verificar)
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartMut = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
    if (!syncing && /\/cart\/change(\.js)?/.test(url)) {
      var rewritten = rewriteChange(init);
      if (rewritten) {
        rewritten.then(function (r) {
          try { r.clone().json().then(rememberCart).catch(function () {}); } catch (e) {}
        }, function () {});
        return rewritten;
      }
    }
    // pre-add determinista: la cookie del codigo queda correcta ANTES de agregar,
    // asi el drawer que regresa en la misma respuesta ya trae el precio bueno
    if (/\/cart\/add(\.js)?/.test(url)) {
      var wants = addWantsSub(init);
      if (wants !== null) {
        var args = arguments;
        var self = this;
        var preCode = wants ? CODE : (addWantsGift(init) ? GIFTCODE : (addWantsSupply(init) ? SUPCODE : NOCODE));
        var pre = origFetch('/discount/' + preCode, { credentials: 'same-origin' }).catch(function () {});
        var p2 = pre.then(function () { return origFetch.apply(self, args); });
        p2.then(function (r) {
          try { r.clone().json().then(rememberCart).catch(function () {}); } catch (e) {}
          if (!syncing) syncSoon();
        }, function () {});
        return p2;
      }
    }
    var p = origFetch.apply(this, arguments);
    if (isCartMut) {
      p.then(function (r) {
        try { r.clone().json().then(rememberCart).catch(function () {}); } catch (e) { /* respuesta no-JSON */ }
        if (!syncing) syncSoon();
      }, function () {});
    }
    return p;
  };

  // Candado 2: al cargar la pagina y al volver del checkout (bfcache)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncNow(); });
  } else {
    syncNow();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncNow(); });

  new MutationObserver(function () { if (upPaused) hideUp(); }).observe(document.documentElement, { childList: true, subtree: true });
  hideUp();

  // Tarjeta inteligente del drawer: ducha adicional / activar suscripcion (delegado, AJAX-safe)
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('.js-lpf-up-qty');
    var su = e.target.closest && e.target.closest('.js-lpf-up-sub');
    var btn = q || su;
    if (!btn || btn.dataset.lpfBusy === '1') return;
    e.preventDefault();
    btn.dataset.lpfBusy = '1';
    var body, url;
    if (q) {
      url = '/cart/change.js';
      body = { id: btn.dataset.key, quantity: parseInt(btn.dataset.qty, 10) };
    } else {
      url = '/cart/add.js';
      body = { items: [{
        id: parseInt(btn.dataset.variant, 10),
        quantity: parseInt(btn.dataset.qty, 10) || 1,
        selling_plan: parseInt(btn.dataset.plan, 10),
        properties: {}
      }] };
      body.items[0].properties[PROP] = btn.dataset.parent;
    }
    var ids = sectionIds();
    if (ids) { body.sections = ids; body.sections_url = window.location.pathname; }
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (c) {
      rememberCart(c);
      pauseUp();
      paint(c && c.sections);
    }).catch(function () {}).finally(function () { delete btn.dataset.lpfBusy; });
  });

  // Upsell de filtros de repuesto en el drawer (oferta suministro): el fetch parcheado
  // aplica SUMINISTRO200 antes del add porque el body trae la variante del filtro
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.js-lpf-fup');
    if (!btn || btn.dataset.lpfBusy === '1') return;
    e.preventDefault();
    btn.dataset.lpfBusy = '1';
    var body = { items: [{ id: parseInt(btn.dataset.variant, 10), quantity: parseInt(btn.dataset.qty, 10) || 1 }] };
    var ids = sectionIds();
    if (ids) { body.sections = ids; body.sections_url = window.location.pathname; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (c) {
      rememberCart(c);
      paint(c && c.sections);
    }).catch(function () {}).finally(function () { delete btn.dataset.lpfBusy; });
  });

  // Carro 2.0 (dormido): cantidad / eliminar delegado (el drawer llega por AJAX)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.js-lpf2-qty');
    if (!btn || btn.dataset.lpfBusy === '1') return;
    e.preventDefault();
    btn.dataset.lpfBusy = '1';
    var qty = parseInt(btn.dataset.qty, 10);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: btn.dataset.key, quantity: qty > 0 ? qty : 0 })
    }).then(function () { paint(null); }).catch(function () {}).finally(function () { delete btn.dataset.lpfBusy; });
  });

  // Candado 3: el click de checkout valida cantidades Y el codigo ANTES de navegar
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], a[href^="/checkout"]');
    if (!btn || btn.dataset.lpfOk === '1') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    syncNow().then(function () {
      return getCart().then(function (cart) { return syncCode(cart); });
    }).catch(function () {}).then(function () {
      btn.dataset.lpfOk = '1';
      btn.click();
      setTimeout(function () { delete btn.dataset.lpfOk; }, 800);
    });
  }, true);
})();
